import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 420px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 130px;
`;
